export default function OnFile(){
  return {
    restrict: "A",
    scope:{
      onFile: "&"
    },
    link: function(scope, element, attr){
      console.log("element", element, scope);
      element.on("change", function(){
        scope.onFile({$file: element[0].files[0]})
      });
    }
  }
}


// WEBPACK FOOTER //
// ./src/util/OnFile.js